<template>
  <span></span>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
export default {
  name: "RefreshToken",
  mounted () {
    const queries = this.$route.query;
    const allowedPages = ['campaign-is-over', 'terms', 'faq', 'receipt-reupload', 'product-reupload', 'iban-reupload', 'error']
    if (allowedPages.includes(queries.page)) return;
    this.refreshTempId().then(customerToken => {
      console.log('CUSTOMER TOKEN')
      this.setCustomerToken(customerToken);
    })
  },
  methods: {
    ...mapMutations(['setCustomerToken']),
    ...mapActions(['refreshTempId'])
  }
};
</script>
